const arcDefaults = {
  startColor: '#FFFFFF',
  startColorOpacity: 1,
  endColor: '#FFFFFF',
  endColorOpacity: 1,
  height: 0.25,
  radius: 1.5,
};

export default arcDefaults;
